module.exports = __webpack_public_path__ + "img/tutorial-2.0ffffb80.jpg";